export default "__VITE_ASSET__DGh$WGhV__"